import src from "IMAGE";
export default { src, width: 307, height: 77, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ALG+1v+Drtf/ibHY/6jC3v/06On/8OTj//Hl5P/44+L/ALXA1v+Jsdj/kbba/63E3//z6Oj/7eHg/+7i4v/44+L/9MY3OTC4FuYAAAAASUVORK5CYII="};
